import { useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../app/hooks";
import { setIFrameLink } from "../app/slice/appSlice";
import { getToken } from "../services/auth.service";
import { WIDGET_EDITOR_URL } from "../config";

interface EditorParams {
  conditionId?: string;
  slotNo?: string;
  page?: string;
  openEditor?: boolean;
  platformStoreId?: string;
  variant?: string;
  slotId?: string;
  productPageVariant?: string;
  productPageSlotId?: string;
  activePages?: string;
  openSlotPreview?: boolean;
}

export const useEditorInitialization = (params: EditorParams, dispatch: ReturnType<typeof useAppDispatch>) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const location = useLocation();

  const initializeEditor = useCallback(async () => {
    if (
      !params.conditionId ||
      !params.slotNo ||
      !params.page ||
      !params.openEditor ||
      !params.platformStoreId ||
      !params.variant
    ) {
      return;
    }

    try {
      const tokenRes = await getToken(params.platformStoreId);

      if (!tokenRes.response?.token) {
        console.error("No token received from getToken");
        return;
      }

      const link = `${WIDGET_EDITOR_URL}?variant=${params.variant}${
        params.page ? `&type=${params.page}` : ""
      }&platformStoreId=${params.platformStoreId}&token=${tokenRes.response.token}&conditionId=${params.conditionId}&slotId=${params.slotId}&slotNo=${params.slotNo}&productPageVariant=${params.productPageVariant}&productPageSlotId=${params.productPageSlotId}&activePages=${params.activePages}&openSlotPreview=${params.openSlotPreview}`;

      dispatch(setIFrameLink(link));
      setIsInitialized(true);

      // Clean up URL by removing fbq parameter
      const queryParams = new URLSearchParams(location.search);
      const timestamp = queryParams.get("timestamp");

      queryParams.forEach((value, key) => {
        queryParams.delete(key);
      });

      const newUrl = `${location.pathname}?timestamp=${timestamp}`;

      window.history.replaceState({}, "", newUrl);
    } catch (error) {
      console.error("Failed to initialize editor:", error);
    }
  }, [params, dispatch, location.search, location.pathname]);

  return { initializeEditor, isInitialized };
};
